import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = { class: "min-h-full" }
const _hoisted_3 = { class: "p-4 bg-white" }
const _hoisted_4 = { class: "flex overflow-x-scroll scrolling-touch items-start hidden-scrollbar" }
const _hoisted_5 = { class: "flex flex-nowrap" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "mt-1 h-8 w-8" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "mx-1 w-[90%] h-full text-xs text-gray-500 text-center text-ellipsis" }
const _hoisted_10 = {
  key: 0,
  class: "absolute top-0 -right-1 px-1 py-1 text-white rounded-md bg-red-600",
  style: {"font-size":"6px"}
}
const _hoisted_11 = {
  key: 0,
  class: "flex mt-2"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("svg", {
  class: "flex-shrink-0 h-5 w-5 text-gray-400",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("svg", {
  class: "flex-shrink-0 h-5 w-5 text-gray-400",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_14 = { class: "pt-4" }
const _hoisted_15 = { class: "mt-4 max-w-3xl mx-auto sm:px-6 lg:px-8 overflow-x-hidden" }
const _hoisted_16 = {
  role: "list",
  class: "flex flex-col gap-y-4"
}
const _hoisted_17 = { class: "flex justify-between mb-2" }
const _hoisted_18 = { class: "relative flex mt-2 justify-start space-x-3" }
const _hoisted_19 = { class: "flex-shrink-0" }
const _hoisted_20 = ["src"]
const _hoisted_21 = { class: "flex-1 min-w-0" }
const _hoisted_22 = {
  href: "#",
  class: "focus:outline-none"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", {
  class: "absolute inset-0",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_24 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "flex justify-center" }
const _hoisted_27 = { class: "group block aspect-w-10 aspect-h-7 rounded-lg bg-gray-100 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-offset-gray-100 focus-within:ring-indigo-500 overflow-hidden" }
const _hoisted_28 = ["src"]
const _hoisted_29 = { class: "mt-2 block text-sm font-medium text-gray-900 truncate pointer-events-none" }
const _hoisted_30 = { class: "mt-2 flex space-x-6" }
const _hoisted_31 = { class: "inline-flex items-center text-sm" }
const _hoisted_32 = {
  type: "button",
  class: "inline-flex space-x-2 text-gray-400"
}
const _hoisted_33 = ["src"]
const _hoisted_34 = { class: "font-medium text-gray-400" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "replies", -1)
const _hoisted_36 = { class: "flex w-full items-center text-sm" }
const _hoisted_37 = {
  type: "button",
  class: "inline-flex space-x-2 text-gray-400 hover:text-gray-500"
}
const _hoisted_38 = ["src"]
const _hoisted_39 = { class: "font-medium text-gray-400" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "likes", -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "grow" }, " ", -1)
const _hoisted_42 = { clas: "text-xs text-gray-400" }
const _hoisted_43 = ["onClick"]
const _hoisted_44 = { class: "flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0" }
const _hoisted_45 = { class: "relative w-full transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6" }
const _hoisted_46 = { class: "mt-5 sm:mt-6" }
const _hoisted_47 = { class: "group block w-full text-center aspect-w-10 aspect-h-7 rounded-lg bg-gray-100 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-offset-gray-100 focus-within:ring-indigo-500 overflow-hidden" }
const _hoisted_48 = ["src"]
const _hoisted_49 = { class: "mt-2 block text-sm font-medium text-gray-900 truncate pointer-events-none" }
const _hoisted_50 = ["onClick"]

import Customer from "@/models/Customer";
import Timeline from "@/models/Timeline";
import { formatSnsTime } from "@/utils/TextUtil";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import axios from "axios";
import { Auth, Storage } from "aws-amplify";
import Followable from "@/models/Followable";
import { computed, onMounted, ref } from "vue";

// import {
//   Disclosure,
//   DisclosureButton,
//   DisclosurePanel,
//   Menu,
//   MenuButton,
//   MenuItem,
//   MenuItems,
// } from "@headlessui/vue";
// import { BellIcon, MenuIcon, XIcon } from "@heroicons/vue/solid";

import AppHeader from "@/components/AppHeader.vue";
// import Customer from "../models/Customer";
// import Followable from "../models/Followable";
// import Timeline from "../models/Timeline";
// import { Auth } from "aws-amplify";
// import axios from "axios";
// import {
//   formatSnsTime,
//   formatStampTypeTitle,
//   formatRelationshipLabel,
// } from "../utils/TextUtil";

// @Options({
//   components: {
//     Disclosure,
//     DisclosureButton,
//     DisclosurePanel,
//     Menu,
//     MenuButton,
//     MenuItem,
//     MenuItems,
//     BellIcon,
//     MenuIcon,
//     XIcon,
//     AppHeader,
//   },
// })
// export default class HomeView extends Vue {


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

// import { Options, Vue } from "vue-class-component";

const store = useStore();
const route = useRoute();

const followees = ref<Followable[]>([]);
const selected_followee = ref<Followable | null>(null);
const timelines = ref<Timeline[]>([]);

const showing_modal = ref<boolean>(false);
const target_timeline = ref<Timeline | null>(null);

const context_id = computed<string>(() => {
  // console.log(`context_id`);
  if (route.query["ci"]) {
    return route.query["ci"] as string;
  }

  return store.state.customer!.id;
});

const customer_id = computed<string>(() => {
  return store.state.customer!.id;
});

const is_customer_context = computed((): boolean => {
  return context_id.value == store.state.customer!.id;
});

const formatdt = (dt: Date | null) => {
  return formatSnsTime(dt);
};

const refresh = () => {
  // console.log("refresh");
  store.dispatch("setLoading", true);
  setTimeout(async () => {
    try {
      if (is_customer_context.value) {
        await refreshFollowersAsync();
      } else {
        await refreshFolloweesAsync();
      }
      await refreshTimelinesAsync();
    } finally {
      store.dispatch("setLoading", false);
    }
  });
};

const refreshFollowersAsync = async () => {
  if (!store.state.customer) {
    return;
  }

  followees.value = await Customer.getFollowers(store.state.customer!.id);

  // console.log(followees);
};

const refreshFolloweesAsync = async () => {
  if (!store.state.customer) {
    return;
  }

  followees.value = await Customer.getFollowees(store.state.customer!.id);

  // console.log(followees);
};

const refreshTimelines = () => {
  // console.log("refresh");
  store.dispatch("setLoading", true);
  setTimeout(async () => {
    try {
      await refreshTimelinesAsync();
    } finally {
      store.dispatch("setLoading", false);
    }
  });
};

const refreshTimelinesAsync = async () => {
  if (!store.state.customer) {
    return;
  }

  if (selected_followee.value) {
    timelines.value = await Timeline.searchByTarget(
      selected_followee.value!.id,
      store.state.customer!.id,
      null
    );

    timelines.value.sort((t1: Timeline, t2: Timeline) => {
      return -1 * (t1.created_at.getTime() - t2.created_at.getTime());
    });
  } else {
    timelines.value = await Timeline.search(
      store.state.customer!.id,
      store.state.customer!.id
    );
  }

  timelines.value.sort((t1: Timeline, t2: Timeline) => {
    return -1 * (t1.created_at.getTime() - t2.created_at.getTime());
  });
};

const setSelectedFollowee = (followee: Followable) => {
  selected_followee.value = followee;
  refreshTimelines();
  markRead(followee);
};

const markRead = (followee: Followable) => {
  if (!followee.hasNew) {
    return;
  }
  followee.setRead();

  setTimeout(async () => {
    const user = await Auth.currentAuthenticatedUser();

    // console.log(user);

    const config = {
      headers: {
        Authorization: `${user.signInUserSession.idToken.jwtToken}}`,
      },
    };

    await axios.post(
      `${process.env.VUE_APP_API_HOST}/read`,
      {
        follower_id: store.state.customer!.id,
        followee_id: followee.id,
      },
      config
    );
  });
};

const onMenuClicked = (timeline: Timeline) => {
  target_timeline.value = timeline;
  showing_modal.value = true;
};

const closeModel = () => {
  target_timeline.value = null;
  showing_modal.value = false;
};

const deleteTimeline = () => {
  store.dispatch("setLoading", true);
  setTimeout(async () => {
    try {
      const target = target_timeline.value!;
      await Timeline.delete(target!.id);

      timelines.value.splice(timelines.value.indexOf(target), 1);

      closeModel();
    } finally {
      store.dispatch("setLoading", false);
    }
  });
};

onMounted(() => {
  refresh();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_fa = _resolveComponent("fa")!
  const _component_text_clamp = _resolveComponent("text-clamp")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(AppHeader),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(followees.value, (followee) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: followee.id,
                  class: _normalizeClass(["relative flex flex-col mx-2 h-20 w-24 justify-center items-center p-2 border border-gray-100 rounded-md", { 'bg-gray-100': selected_followee.value == followee }]),
                  onClick: ($event: any) => (setSelectedFollowee(followee))
                }, [
                  _createElementVNode("span", _hoisted_7, [
                    _createElementVNode("img", {
                      src: 
                      followee.selfie_image_url ?? (followee.type == 'temple' ? require('@/assets/images/no-selfie-temple.png') : require('@/assets/images/no-selfie.png'))
                    ,
                      class: "h-8 w-8 rounded-full"
                    }, null, 8, _hoisted_8)
                  ]),
                  _createElementVNode("span", _hoisted_9, _toDisplayString(followee.display_name), 1),
                  (followee.hasNew)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, "NEW"))
                    : _createCommentVNode("", true)
                ], 10, _hoisted_6))
              }), 128))
            ])
          ]),
          (!!selected_followee.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                (
                selected_followee.value?.type == 'temple' &&
                selected_followee.value.has_wish_menu_v
              )
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      class: "inline-flex justify-center px-4 py-2 mr-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50",
                      to: `/order/wish/${selected_followee.value.id}`
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 宇宙祈願 ")
                      ]),
                      _: 1
                    }, 8, ["to"]))
                  : _createCommentVNode("", true),
                (
                selected_followee.value?.type == 'temple' &&
                selected_followee.value.has_memorial_menu_v
              )
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 1,
                      class: "inline-flex justify-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50",
                      to: `/order/pray/${selected_followee.value.id}`
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 宇宙供養 ")
                      ]),
                      _: 1
                    }, 8, ["to"]))
                  : _createCommentVNode("", true),
                (selected_followee.value?.type == 'temple')
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 2,
                      to: `/temples/${selected_followee.value.id}`,
                      class: "flex items-center ml-4 text-sm font-medium text-gray-500 hover:text-gray-700 border-b-1 border-gray-500"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(selected_followee.value.display_name) + "のページ", 1),
                        _hoisted_12
                      ]),
                      _: 1
                    }, 8, ["to"]))
                  : _createCommentVNode("", true),
                (selected_followee.value?.type == 'decedent')
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 3,
                      to: `/decedents/${selected_followee.value.id}`,
                      class: "flex items-center ml-4 text-sm font-medium text-gray-500 hover:text-gray-700 border-b-1 border-gray-500"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(selected_followee.value.display_name) + "さんのページ", 1),
                        _hoisted_13
                      ]),
                      _: 1
                    }, 8, ["to"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("main", null, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("ul", _hoisted_16, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(timelines.value, (timeline) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: timeline.id,
                    class: "relative p-4 bg-white"
                  }, [
                    _createVNode(_component_router_link, {
                      to: `/timelines/${timeline.id}`
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("img", {
                                class: "h-6 w-6 rounded-full bg-gray-100",
                                src: 
                              timeline.publisher_selfie_image_url ??
                              require('@/assets/images/no-selfie.png')
                            
                              }, null, 8, _hoisted_20)
                            ]),
                            _createElementVNode("div", _hoisted_21, [
                              _createElementVNode("a", _hoisted_22, [
                                _hoisted_23,
                                _createElementVNode("p", _hoisted_24, _toDisplayString(timeline.publisher_name), 1)
                              ])
                            ])
                          ]),
                          (
                          (timeline.type == 'event' ||
                            timeline.type == 'praying' ||
                            timeline.type == 'album') &&
                          timeline.publisher_id == customer_id.value
                        )
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "w-8",
                                onClick: _withModifiers(($event: any) => (onMenuClicked(timeline)), ["prevent"])
                              }, [
                                _createVNode(_component_fa, {
                                  icon: "ellipsis-v",
                                  class: "text-gray-400"
                                })
                              ], 8, _hoisted_25))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("div", _hoisted_27, [
                            (!!timeline.media_urls && !!timeline.media_urls.length)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: timeline.media_urls[0].original_resource_url,
                                  alt: "",
                                  class: "object-cover pointer-events-none group-hover:opacity-75 max-h-48"
                                }, null, 8, _hoisted_28))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("p", _hoisted_29, _toDisplayString(timeline.title), 1),
                        _createVNode(_component_text_clamp, {
                          html: timeline.body,
                          "max-lines": 2,
                          class: "mt-2 block text-sm font-medium text-gray-900 pointer-events-none"
                        }, null, 8, ["html"]),
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("span", _hoisted_31, [
                            _createElementVNode("button", _hoisted_32, [
                              _createElementVNode("img", {
                                class: "w-4 h-4",
                                src: require('@/assets/images/ic_comment.png')
                              }, null, 8, _hoisted_33),
                              _createElementVNode("span", _hoisted_34, _toDisplayString(timeline.comment_count), 1),
                              _hoisted_35
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_36, [
                            _createElementVNode("button", _hoisted_37, [
                              _createElementVNode("img", {
                                class: "w-5 h-5",
                                src: require('@/assets/images/ic_stamp1_circle.png')
                              }, null, 8, _hoisted_38),
                              _createElementVNode("span", _hoisted_39, _toDisplayString(timeline.stamp_count), 1),
                              _hoisted_40
                            ]),
                            _hoisted_41,
                            _createElementVNode("span", _hoisted_42, _toDisplayString(formatdt(timeline.created_at)), 1)
                          ])
                        ])
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ]),
    (showing_modal.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "fixed inset-0 w-full h-full",
          style: {"background-color":"#999999aa"},
          onClick: _withModifiers(closeModel, ["stop"])
        }, [
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("div", _hoisted_47, [
                  (!!target_timeline.value!.media_urls && !!target_timeline.value!.media_urls.length)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: target_timeline.value!.media_urls[0].original_resource_url,
                        alt: "",
                        class: "object-contain pointer-events-none group-hover:opacity-75 max-h-72"
                      }, null, 8, _hoisted_48))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("p", _hoisted_49, _toDisplayString(target_timeline.value!.title), 1),
                _createVNode(_component_text_clamp, {
                  text: target_timeline.value!.body,
                  "max-lines": 2,
                  class: "mt-2 block text-sm font-medium text-gray-900 pointer-events-none"
                }, null, 8, ["text"]),
                _createElementVNode("button", {
                  type: "button",
                  class: "mt-8 inline-flex w-full justify-center rounded-md border border-transparent bg-red-600 px-4 py-2 text-base font-medium text-white shadow-sm",
                  onClick: _withModifiers(deleteTimeline, ["stop"])
                }, " この投稿を削除 ", 8, _hoisted_50)
              ])
            ])
          ])
        ], 8, _hoisted_43))
      : _createCommentVNode("", true)
  ]))
}
}

})